<template>
  <checkbox :name="name" :id="id" :label="label" :disabled="disabled" :value="value" @input="changed" />
</template>

<script>
import Checkbox from './Checkbox.vue'

export default {
  name: 'toggle-button',
  components: {
    Checkbox
  },
  props: {
    name: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    label: String,
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    changed(value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  display: inline-block;
  margin: 0 0 25px 25px;
  user-select: none;

  /deep/ label {
    font-size: em(24);
    font-weight: 300;
    background-color: #fff;
    border: 2px solid #fff;
    cursor: pointer;
    display: block;
    position: relative;
    width: 300px;
    height: 200px;
    transition: all 200ms;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 90%;
      transform: translate(-50%, -50%);
    }

    span.check {
      display: none !important;
    }
  }

  /deep/ input[type=checkbox]:disabled + label {
    opacity: 0.5;
  }
  /deep/ input[type=checkbox]:checked + label {
    background-color: #CBEEF3;
    border-color: #35BDD1;
  }
}
</style>
